module.exports = __webpack_public_path__ + "img/logo2.37e42339.svg";